import { render, staticRenderFns } from "./CollectionsIdentificationField.vue?vue&type=template&id=1e2e221d"
import script from "./CollectionsIdentificationField.vue?vue&type=script&lang=js"
export * from "./CollectionsIdentificationField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports